/** API route map: URLS.Controller.CandidateSocialMedia */
export const CandidateSocialMedia = {
      Name: 'CandidateSocialMedia/',
      Patch: 'patch',
};
